import { useState, useContext, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { setUserRole } from "../store/Slices/auth/authoriseSlice";
import {
  Box,
  IconButton,
  // InputBase,
  Menu,
  MenuItem,
  Badge,
  Avatar,
  Typography,
  Tooltip,
  Divider,
  useMediaQuery,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Grid,
  CircularProgress,
} from "@mui/material";

import {
  // LightModeOutlined as LightModeOutlinedIcon,
  // DarkModeOutlined as DarkModeOutlinedIcon,
  NotificationsOutlined as NotificationsOutlinedIcon,
  SettingsOutlined as SettingsOutlinedIcon,
  // Search as SearchIcon,
  WidgetsOutlined as WidgetsOutlinedIcon,
  MenuOutlined as MenuOutlinedIcon,
  ArrowBackIosNew,
  ArrowForwardIos,
} from "@mui/icons-material";

import { useTheme } from "@mui/material/styles";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
// import ManageAccountsRoundedIcon from "@mui/icons-material/ManageAccountsRounded";
import Profile from "../assets/imgs/profile.svg";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { tokens } from "../theme";
import { Icon } from "@iconify/react";
import Searchbar from "./top/Searchbar";
import { changePassword, logoutAsync } from "../redux/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { PiUserCircleGearFill } from "react-icons/pi";
import { RiLock2Fill } from "react-icons/ri";
import { FaUserTie } from "react-icons/fa6";
import { PiUserCircleGearLight } from "react-icons/pi";
import { PiLockKeyLight } from "react-icons/pi";
import { PiUserSwitchLight } from "react-icons/pi";

import { useFormik } from "formik";
import * as Yup from "yup";
import { getProfile } from "../redux/profile/profileSlice";

const HEADER_MOBILE = 54;
const HEADER_DESKTOP = 64;

const Topbar = ({ onToggleDrawer, toggleDrawer }) => {
  const [open, setOpen] = useState(false);
  const [openLogout, setOpenLogout] = useState(false);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [notificationCount, setNotificationCount] = useState(2);
  const [isMultiRole, setIsMultiRole] = useState(false);
  const showMobileHeader = useMediaQuery(theme.breakpoints.down("sm"));
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const userRole = "super_admin";
  const userName = localStorage.getItem("userName");
  const profile = useSelector((state) => state.profile.data);
  const authStatus = useSelector((state) => state.auth.status);

  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const formik = useFormik({
    initialValues: {
      old_password: "",
      new_password: "",
      again_new_password: "",
    },
    validationSchema: Yup.object({
      old_password: Yup.string().required("Old Password is required"),
      new_password: Yup.string()
        .required("New Password is required")
        .min(8, "Password must be at least 8 characters")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[0-9]/, "Password must contain at least one number")
        .matches(
          /[!@#$%^&*(),.?":{}|<>]/,
          "Password must contain at least one symbol"
        ),
      again_new_password: Yup.string()
        .oneOf([Yup.ref("new_password"), null], "Passwords must match")
        .required("Again Enter Password is required"),
    }),
    onSubmit: (values) => {
      let userData = {
        previous_password: values.old_password,
        new_password: values.new_password,
      };
      console.log({ userData });

      dispatch(changePassword(userData));
    },
  });

  let isActiveRole = "";
  if (profile?.profile?.role === "BENCH_SALES_RECRUITER") {
    isActiveRole = "Bench Sales Recruiter";
  } else {
    isActiveRole = "IT Recruiter";
  }

  const formattedUserName = userName
    ? userName
        .split("@")[0] // Get the part before '@'
        .replace(/(?:^|\s|\.)(.)/g, (match, letter) => letter.toUpperCase()) // Capitalize the first letter after space or dot
        .replace(/([a-z])([A-Z])/g, "$1 $2") // Add a space between camelCase
    : "";

  function handleSuccessMessage(message) {
    toast.success(message, {
      autoClose: 2000,
      position: "top-center",
    });
  }

  const handleNotificationClick = () => {
    setNotificationCount(0);
  };

  const navigate = useNavigate();

  const handleSettings = (popupState) => {
    navigate("/settings");
    popupState.close();
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    formik.resetForm({
      values: {
        old_password: "",
        new_password: "",
        again_new_password: "",
      },
    });
  };

  const handleClickOpenLogOut = () => {
    setOpenLogout(true);
  };

  const handleCloseLogOut = () => {
    setOpenLogout(false);
  };

  const handleLogout = async () => {
    try {
      setIsLoading(true);
      const response = await dispatch(logoutAsync());
      console.log(response);

      if (response?.meta?.requestStatus === "fulfilled") {
        navigate("/login");
        localStorage.clear();
        window.location.reload();
        handleSuccessMessage("Logout successful");
      }
    } catch (error) {
      navigate("/login");
      localStorage.clear();
      window.location.reload();
      handleSuccessMessage("Logout successful");
      console.error("Logout error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (authStatus === "change_password_succeeded") {
      handleClose();
      formik.resetForm({
        values: {
          old_password: "",
          new_password: "",
          again_new_password: "",
        },
      });
    }
  }, [authStatus]);

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  return (
    <Box
      sx={{
        boxShadow: `0px 1px 4px ${colors.grey[900]}`,
        // position:'fixed'
        height: showMobileHeader ? HEADER_MOBILE : HEADER_DESKTOP,
        borderRadius: "0px 0px",
        bgcolor: colors.background[100],
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
        height={"100%"}
      >
        {/* {!showIconButton && (
          <Box>
            <img
              style={{
                height: "80px",
                padding: "16px",
                transition: "width 0.3s ease-out",
              }}
              src={Logo}
              alt="Logo"
            />
          </Box>
        )} */}
        <Box display="flex">
          <IconButton
            sx={{
              mr: 2,
              "&:hover .icon": {
                animation: "shake 0.3s ease-in-out",
              },
              "@keyframes shake": {
                "0%, 100%": { transform: "translateX(0)" },
                "25%": { transform: "translateX(-2px)" },
                "50%": { transform: "translateX(2px)" },
                "75%": { transform: "translateX(-2px)" },
              },
            }}
            onClick={onToggleDrawer}
          >
            {toggleDrawer ? (
              <Icon
                icon="ri:menu-fold-2-fill"
                style={{ fontSize: "22px" }}
                className="icon"
              />
            ) : (
              <Icon
                icon="ri:menu-unfold-2-fill"
                style={{ fontSize: "22px" }}
                className="icon"
              />
            )}
            {/* {toggleDrawer ? (
              <Icon
                icon="icon-park-outline:menu-fold-one"
                style={{ fontSize: "22px" }}
                className="icon"
              />
            ) : (
              <Icon
                icon="icon-park-solid:menu-unfold-one"
                style={{ fontSize: "22px" }}
                className="icon"
              />
            )} */}
          </IconButton>

          {/* )} */}
          {/* <ArrowBackIosNew/>
<ArrowForwardIos/> */}

          {/* SEARCH BAR */}
          {userRole === "staff" && <Searchbar />}
        </Box>

        {/* ICONS */}
        <Box display="flex" alignItems="center">
          {isMultiRole && (
            <PopupState variant="popover" popupId="demo-popup-menu">
              {(popupState) => (
                <Box>
                  <Tooltip title="Roles Switch">
                    <IconButton {...bindTrigger(popupState)} sx={{ mr: 1 }}>
                      <WidgetsOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                  <Menu
                    {...bindMenu(popupState)}
                    sx={{
                      mt: 2,
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        // mb:'4px'
                      }}
                    >
                      <Icon
                        icon="fluent:window-multiple-16-filled"
                        height={15}
                        width={15}
                      />
                      <Typography variant="body2" ml={0.2}>
                        Manage User Roles
                      </Typography>
                    </Box>
                    <Divider sx={{ my: 1 }} />
                    <Box
                      sx={{
                        m: "1px 9px",
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gap: "8px",
                      }}
                    ></Box>
                  </Menu>
                </Box>
              )}
            </PopupState>
          )}
          {/* <Tooltip
            title={
              theme.palette.mode === "light"
                ? "Toggle Dark Mode"
                : "Toggle Light Mode"
            }
          >
            <IconButton onClick={colorMode.toggleColorMode} sx={{ mr: 1 }}>
              {theme.palette.mode === "dark" ? (
                <DarkModeOutlinedIcon />
              ) : (
                // <Icon icon="moon-loop" />
                <LightModeOutlinedIcon />
                // <Icon icon="moon-to-sunny-outline-loop-transition" />
              )}
            </IconButton>
          </Tooltip> */}

          {/* <IconButton onClick={handleNotificationClick} sx={{ mr: 1 }}>
            <Badge badgeContent={notificationCount} color="info">
              <NotificationsOutlinedIcon color="action" />
            </Badge>
          </IconButton> */}
          {/* {(userRole === "staff" ||
            userRole === "admin" ||
            userRole === "spoc") && <NotificationsPopover />} */}

          {/* <NotificationDropdown /> */}

          {/* <NotificationDropdown/> */}

          <PopupState variant="popover" popupId="demo-popup-menu">
            {(popupState) => (
              <>
                <Box
                  sx={{
                    ml: 0.4,
                    mr: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "end",
                  }}
                >
                  <Typography
                    variant="h6"
                    // color={colors.blueAccent[200]}
                    color="#454545"
                    fontSize="14px"
                    lineHeight="1"
                    fontWeight="600"
                    fontFamily="Calibri"
                  >
                    {profile?.profile?.full_name}
                    {/* {profile?.profile?.full_name
                      ?.split(" ")
                      ?.slice(0, 2)
                      ?.join(" ")} */}
                  </Typography>
                  <Typography
                    // variant="h6"
                    // fontWeight="bold"
                    color="#a3a3a3"
                    fontSize="14px"
                  >
                    {profile?.profile?.role === "BENCH_SALES_RECRUITER"
                      ? "Bench Sales Recruiter"
                      : "IT Recruiter"}
                  </Typography>
                </Box>
                <Tooltip title="Profile" arrow>
                  {/* <Avatar
                    alt="Remy Sharp"
                    src={Profile}
                    sx={{ width: 32, height: 32, ml: 1, cursor: "pointer" }}
                    {...bindTrigger(popupState)}
                  /> */}
                  <img
                    src={profile?.profile?.profile_picture}
                    alt="profile"
                    // height="30px"
                    // width="30px"
                    style={{
                      width: 35,
                      height: 35,
                      ml: 1,
                      cursor: "pointer",
                      borderRadius: "50%",
                    }}
                    {...bindTrigger(popupState)}
                  />
                </Tooltip>
                <Menu {...bindMenu(popupState)} sx={{ mt: 2.5, px: 3 }}>
                  <Box sx={{ py: 1, px: 2 }}>
                    {/* <Typography
                      variant="h6"
                      fontWeight="bold"
                      color={colors.blueAccent[200]}
                      sx={{ ml: 0.4, mt: -0.8 }}
                    >
                      {profile?.profile?.full_name}
                    </Typography> */}
                    <Badge
                      color="secondary"
                      badgeContent="active"
                      variant="dot"
                    >
                      <Typography
                        fontWeight="bold"
                        variant="caption"
                        sx={{
                          bgcolor: colors.grey[900],
                          px: 0.8,

                          borderRadius: 1,
                        }}
                      >
                        {isActiveRole ? isActiveRole : "Email Address"}
                      </Typography>
                    </Badge>
                  </Box>
                  <Divider />
                  <MenuItem
                    onClick={() =>
                      navigate("/profile-save", {
                        state: { userDetails: profile?.profile },
                      })
                    }
                    sx={{
                      borderRadius: 1,
                      minWidth: 125,
                      m: "2px 10px",
                      mt: 1,
                    }}
                  >
                    <PiUserCircleGearLight
                      style={{ marginRight: "10px", fontSize: "20px" }}
                    />
                    Update Profile
                  </MenuItem>

                  <MenuItem
                    onClick={handleClickOpen}
                    sx={{
                      borderRadius: 1,
                      minWidth: 125,
                      m: "2px 10px",
                      mt: 1,
                    }}
                  >
                    <PiLockKeyLight
                      style={{ marginRight: "10px", fontSize: "20px" }}
                    />
                    Change Password
                  </MenuItem>
                  <MenuItem
                    onClick={() => navigate("/login")}
                    sx={{
                      borderRadius: 1,
                      minWidth: 125,
                      m: "2px 10px",
                      mt: 1,
                    }}
                  >
                    <PiUserSwitchLight
                      style={{ marginRight: "10px", fontSize: "20px" }}
                    />
                    {profile?.profile?.role === "BENCH_SALES_RECRUITER"
                      ? "Switch to IT Recruiter"
                      : "Switch to Bench Sales"}
                  </MenuItem>

                  {/* <MenuItem
                    onClick={popupState.close}
                    sx={{
                      borderRadius: 1,
                      minWidth: 125,
                      m: "2px 10px",
                    }}
                  >
                    <ManageAccountsRoundedIcon sx={{ mr: 1 }} />
                    Manage Account
                  </MenuItem> */}

                  {/* <Box className={styles.contain_details}>
                    <PiUserCircleFill
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography sx={{ marginLeft: "10px", cursor: "pointer" }}>
                      <b>{profile?.profile?.full_name}</b>
                    </Typography>
                  </Box>

                  <Box className={styles.contain_details}>
                    <PiUserCircleGearFill
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography
                      sx={{ marginLeft: "10px", cursor: "pointer" }}
                      onClick={() =>
                        navigate("/profile-save", {
                          state: { userDetails: profile?.profile },
                        })
                      }
                    >
                      <b>Update Profile</b>
                    </Typography>
                  </Box> */}

                  {/* <Box className={styles.contain_details}>
                    <RiLock2Fill
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography
                      sx={{ marginLeft: "10px", cursor: "pointer" }}
                      onClick={handleClickOpen}
                    >
                      <b>Change Password</b>
                    </Typography>
                  </Box> */}

                  {/* <Box className={styles.contain_details}>
                    <PiUserSwitchFill
                      style={{ fontSize: "25px", color: customTextColor }}
                    />
                    <Typography sx={{ marginLeft: "10px", cursor: "pointer" }}>
                      <b>Switch to Bench Sales</b>
                    </Typography>
                  </Box> */}
                  {/* 
                  <MenuItem
                    onClick={() => handleSettings(popupState)}
                    sx={{
                      borderRadius: 1,
                      minWidth: 125,
                      m: "2px 10px",
                    }}
                    // disabled
                  >
                    <SettingsOutlinedIcon sx={{ mr: 1 }} />
                    Settings
                  </MenuItem> */}
                  <Divider />
                  <MenuItem
                    disabled={isLoading}
                    onClick={handleLogout}
                    // onClick={handleClickOpenLogOut}
                    sx={{
                      borderRadius: 1,
                      minWidth: 25,
                      marginTop: "20px",
                      m: "3px 10px",
                      // "&:hover": {
                      //   backgroundColor: colors.redAccent[800], // Change to your desired hover color
                      // },
                    }}
                  >
                    {/* <LogoutOutlinedIcon sx={{ mr: 1 }} /> */}
                    Logout
                  </MenuItem>
                </Menu>
              </>
            )}
          </PopupState>
        </Box>
      </Box>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
        // fullWidth
        sx={{ "& .MuiDialog-paper": { width: "40%", maxHeight: "90vh" } }}
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{ color: "#3856a6", marginTop: "10px" }}
        >
          {"Chnage Password"}
        </DialogTitle>
        {/* <DialogContent></DialogContent> */}
        <form onSubmit={formik.handleSubmit}>
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              sx={{ padding: "0 10px" }}
            >
              {/* <div className="signup_form_group" style={{ padding: "0 10px" }}>
                <span className="field_icon">
                  <IoIosMailOpen />
                  <TextField
                    type="text"
                    name="email"
                    placeholder="Email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                    sx={{ width: "100%", backgroundColor: "#fff" }}
                  />
                </span>

                {formik.touched.email && formik.errors.email ? (
                  <div className="login_error">{formik.errors.email}</div>
                ) : null}
              </div> */}
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  sx={{ padding: "0 10px 15px" }}
                  // className="login-form"
                >
                  <div
                    className="signup_form_group"
                    style={{
                      marginBottom: "0",
                      padding: "0 10px",
                      paddingLeft: "10px",
                    }}
                  >
                    <span className="field_icon">
                      <RiLock2Fill style={{ left: "33px" }} />
                      <TextField
                        type="text"
                        name="old_password"
                        placeholder="Enter Old Password"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.old_password}
                        sx={{
                          width: "100%",
                          paddingLeft: "10px",
                          backgroundColor: "#fff",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "none !important",
                            },
                          },
                        }}
                      />
                    </span>
                  </div>
                  {formik.touched.old_password && formik.errors.old_password ? (
                    <div className="login_error" style={{ marginLeft: "20px" }}>
                      {formik.errors.old_password}
                    </div>
                  ) : null}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  sx={{ padding: "0 10px 15px" }}
                  // className="login-form"
                >
                  <div
                    className="signup_form_group"
                    style={{
                      marginBottom: "0",
                      padding: "0 10px",
                    }}
                  >
                    <span className="field_icon">
                      <RiLock2Fill style={{ left: "33px" }} />
                      <TextField
                        type="text"
                        name="new_password"
                        placeholder="Enter New Password"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.new_password}
                        sx={{
                          width: "100%",
                          paddingLeft: "10px",
                          backgroundColor: "#fff",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "none !important",
                            },
                          },
                        }}
                      />
                    </span>
                  </div>
                  {formik.touched.new_password && formik.errors.new_password ? (
                    <div className="login_error" style={{ marginLeft: "20px" }}>
                      {formik.errors.new_password}
                    </div>
                  ) : null}
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  sx={{ padding: "0 10px 15px" }}
                  // className="login-form"
                >
                  <div
                    className="signup_form_group"
                    style={{
                      marginBottom: "0",
                      padding: "0 10px",
                    }}
                  >
                    <span className="field_icon">
                      <RiLock2Fill style={{ left: "33px" }} />
                      <TextField
                        type="text"
                        name="again_new_password"
                        placeholder="Again Enter New Password"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.again_new_password}
                        sx={{
                          width: "100%",
                          paddingLeft: "10px",
                          backgroundColor: "#fff",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "none !important",
                            },
                          },
                        }}
                      />
                    </span>
                  </div>
                  {formik.touched.again_new_password &&
                  formik.errors.again_new_password ? (
                    <div className="login_error" style={{ marginLeft: "20px" }}>
                      {formik.errors.again_new_password}
                    </div>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
        <DialogActions className="forgot_password_modal_btns">
          <button
            type="submit"
            onClick={formik.handleSubmit}
            style={authStatus === "loading" ? { padding: "7px 40px" } : {}}
          >
            {authStatus === "loading" ? (
              <CircularProgress size={12} sx={{ color: "#fff" }} />
            ) : (
              "Confirm"
            )}
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={openLogout}
        onClose={handleCloseLogOut}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
        // fullWidth
        sx={{ "& .MuiDialog-paper": { width: "40%", maxHeight: "90vh" } }}
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{ color: "#3856a6", marginTop: "10px" }}
        >
          {"Logout!"}
        </DialogTitle>
        <DialogContent>Are you sure you want to logout?</DialogContent>

        <DialogActions className="forgot_password_modal_btns">
          <button disabled={isLoading} onClick={handleLogout}>
            Yes
          </button>
          <button onClick={handleCloseLogOut}>No</button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Topbar;
